import { useAppSelector } from 'state/store';
import { getBrand } from 'state/brand';
import { useCustomNavigate } from 'hooks/useCustomNavigate';

export const useTermsAndConditionsVM = () => {
    const { navigateToCardPayment } = useCustomNavigate();

    const brand = useAppSelector(getBrand);

    return {
        navigateToCardPayment,
        brandName: brand?.name ?? '',
    };
};
